import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QuizProgressState } from '../reducers/quiz-progress.reducer';
import { QUIZ_PROGRESS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<QuizProgressState>(QUIZ_PROGRESS_FEATURE_KEY);

export const selectQuizId = createSelector(selectState, (state) => state.quizId);
export const selectProgress = createSelector(selectState, (state) => state.progress);
export const selectLoading = createSelector(selectState, (state) => state.loading);
export const selectLoaded = createSelector(selectState, (state) => state.loaded);
export const selectSaving = createSelector(selectState, (state) => state.saving);
export const selectSaved = createSelector(selectState, (state) => state.saved);
export const selectRetrying = createSelector(selectState, (state) => state.retrying);
export const selectIsFinished = createSelector(selectProgress, (progress) => progress?.finished ?? false);
export const selectIsPassed = createSelector(selectProgress, (progress) => progress?.passed ?? false);
export const selectAnswers = createSelector(selectProgress, (progress) => progress?.answers ?? []);

export const selectSelectedOption = (questionId: string) =>
    createSelector(selectProgress, (progress) => {
        if (!progress) return null;
        const answer = progress.answers.find((a) => a.questionId === questionId);
        return answer?.optionId ?? null;
    });
